import React from 'react';
import ReactModal from 'react-modal';
import { Heading, Paragraph } from '../typography';
import Button from '../button';
import { Link } from '../link';
import Close from '../svg/Close';
import clsx from 'clsx';
import { colors } from '../foundation';

type Props = {
  isOpen: boolean;
  title: string;
  text: string;
  buttonText: string;
  hyperlinkText?: string;
  hyperlinkHref?: string;
  variant: 'content' | 'confirmation';
  onClose: () => void;
  onClick: () => void;
};

const Popup = ({ isOpen, title, text, buttonText, hyperlinkText, hyperlinkHref, variant, onClose, onClick }: Props) => {
  //This is needed so screen readers don't see main content when modal is opened.
  React.useEffect(() => {
    ReactModal.setAppElement('body');
  }, []);

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel={title}
      htmlOpenClassName="overflow-hidden"
      overlayClassName={'z-20 flex fixed inset-0 justify-center items-center bg-black-100/50 p-16 lg:p-32'}
      className={clsx(
        'relative max-h-full max-w-xl overflow-y-scroll rounded-28 bg-gradient-to-bl from-[#660713] to-red-100 p-8 shadow-xl outline-none lg:max-w-3xl'
      )}
    >
      <div className="flex justify-end">
        <button aria-label={'Close'} className="m-8 flex h-32 w-32 items-center justify-center" onClick={onClose}>
          <Close color={colors.primary.white} />
        </button>
      </div>
      <div
        className={`relative p-16 lg:px-[60px] ${clsx({
          'text-center': variant === 'content',
        })}`}
      >
        <Heading variant={'small'} classes={'text-white-100'}>
          {title}
        </Heading>
        <Paragraph variant={'medium'} classes={clsx('pt-16 text-white-100')}>
          {text}
        </Paragraph>
      </div>
      <div
        className={`flex items-center gap-24 py-[20px] ${clsx({
          'justify-end px-24': variant === 'confirmation',
          'flex-col-reverse': variant === 'content',
        })}`}
      >
        <>
          {hyperlinkHref && hyperlinkText && <Link label={hyperlinkText} href={hyperlinkHref} size={'large'} />}
          <Button label={buttonText} variant={'primary'} onClick={onClick} />
        </>
      </div>
    </ReactModal>
  );
};
export default Popup;
